module.exports = __webpack_public_path__ + "img/am12.98f850c4.jpg";